import React, { useState } from 'react'
import Form from 'antd/lib/form'
import Switch from 'antd/lib/switch'
import Tooltip from 'antd/lib/tooltip'
import Typography from 'antd/lib/typography'
import { QuestionCircleOutlined } from '@ant-design/icons'

interface AutoAcceptProps {
  inputName: string
  formRef?: any
  isPreOrder: boolean
  isDelivery: boolean
}

const AutoAccept = ({
  formRef,
  inputName,
  isPreOrder,
  isDelivery
}: AutoAcceptProps) => {
  const initialValue = (formRef && formRef.getFieldValue(inputName)) || 0
  const [enabled, setEnabled] = useState<boolean>(initialValue?.auto_accept)

  const titleType = isPreOrder
    ? isDelivery
      ? 'pre-order delivery'
      : 'pre-order pickup'
    : isDelivery
    ? 'same day delivery'
    : 'same day pick up'

  const updateValue = (value: boolean) => {
    setEnabled(value)
    formRef.setFieldsValue({
      [inputName]: {
        ...initialValue,
        auto_accept: value
      }
    })
  }

  return (
    <Form.Item style={{ marginBottom: '8px' }} name={inputName}>
      <Switch
        defaultChecked={enabled}
        onChange={(value) => updateValue(value)}
        style={{ marginRight: '8px' }}
        data-testid='order-limit'
      />
      <Typography.Text
        style={{ display: 'inline-block', verticalAlign: 'middle' }}
      >
        Enable auto accept
        <Tooltip
          placement='bottom'
          title={`Turn this on to automatically accept all incoming ${titleType} orders. You won’t be able to reject them once they’re placed.`}
        >
          <QuestionCircleOutlined style={{ marginLeft: '4px' }} />
        </Tooltip>
      </Typography.Text>
    </Form.Item>
  )
}

export default AutoAccept
